export function getClosestItems<T = string | string[]>(items: T[], selectedIdx: number, numberOfItems: number): T[] {
  if (items.length <= numberOfItems) {
    return items;
  }
  if (selectedIdx <= 0) {
    return items.slice(0, numberOfItems);
  }
  if (selectedIdx >= items.length - 1) {
    return items.slice(-numberOfItems);
  }
  const half = Math.floor(numberOfItems / 2);
  let start = selectedIdx - half;
  let end = selectedIdx + half + (numberOfItems % 2);
  if (start < 0) {
    end += -start;
    start = 0;
  }
  if (end > items.length) {
    start -= end - items.length;
    end = items.length;
  }
  return items.slice(start, end);
}
